import script from "./Ad.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ad.vue?vue&type=script&setup=true&lang=ts"

import "./Ad.vue?vue&type=style&index=0&id=3505c18c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3505c18c"]])

export default __exports__